import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import Constants from "../../Action/Constants";

class FinancialStatementCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(): void {
    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS
    });
  }
}

export { FinancialStatementCreate };
